import { useContext, useEffect } from "react";
import { MapContext } from "../../MapContext";
import { registerOlInteraction } from "../helpers";

import { DragPan } from "ol/interaction";

export default function DragPanInteraction(props) {
  const context = useContext(MapContext);

  const options = {
    condition: undefined,
    kinetic: undefined
  };

  const events = {
    change: undefined,
    "change:active": undefined,
    error: undefined,
    propertychange: undefined
  };

  useEffect(
    () =>
      registerOlInteraction(context, DragPan, props, options, events),
    []
  );

  return null;
}
